export type LinkData = GatsbyLinkData | AnchorLinkData

export interface GatsbyLinkData {
  type: 'gatsby'
  external: false
  blank: boolean
  to: string
}

export interface AnchorLinkData {
  type: 'anchor'
  external: boolean
  blank: boolean
  href?: string
}

export const isExternalUrl = (url: string): boolean => {
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}

export const normalizeInternalLink = (href: string): string => {
  if (href.startsWith('/')) {
    return `${href}`
  }
  if (href.startsWith('#')) {
    return `${href}`
  }
  return `/${href}`
}

export const normalizeLink = (
  link: string | undefined,
  options?: { target?: string },
): LinkData => {
  const { target } = options || {}
  const blank = target === '_blank'
  if (!link) {
    return {
      type: 'anchor',
      external: false,
      blank,
    }
  }
  const external = isExternalUrl(link)
  const isServerlessFunctionUrl = link.startsWith('/api/')
  if (isServerlessFunctionUrl || external || blank) {
    return {
      type: 'anchor',
      external,
      href: link,
      blank,
    }
  }
  return {
    type: 'gatsby',
    external: false,
    to: normalizeInternalLink(link),
    blank,
  }
}
